export default "__VITE_ASSET__a28a076c__"